var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'dark-mode': _vm.darkMode, 'light-mode': !_vm.darkMode }},[_c(_vm.layout,{tag:"component",on:{"toggle-dark-mode":_vm.handleDarkModeToggle}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }